<template>
  <div>

     <div class="loader" v-bind:class=" { active: !isReady } "></div>
  <div id="app" v-bind:class=" { active: isReady } ">

   

    <navbar />
  <!--   <transition name="fade"> -->
    <transition
        name="fade"
        mode="out-in"
      >
    <router-view id="my-router-view" v-bind:class=" { active: isActive } "></router-view>
      </transition>
   <!--  </transition> -->

    <footbar />


    <div id="rotate-warning">
      <div id="rotate-container">
        <div id="rotate-sprite"></div>
        <h3>Please rotate your device</h3>
      </div>
    </div>

  </div>
</DIV>
</template>

<script>
import footbar from './components/Footbar.vue'
import navbar from './components/Navbar.vue'
import {loadArray} from '../content.json'
import {commontools} from './mixins/Styling'

export default {
  name: 'app',
  mixins: [commontools],
  data: function () {
    return {
      loadArray,
      isActive: true,
      isReady: false,
      loadCounter: 0
    }
  },
  methods: {
    loadImages () {
      this.loadArray.map(url => {
        this.preloadImages('static/img/content/'+url).then(myimg => {
          this.loadCounter--
          if (this.loadCounter === 0) this.isReady = true
        })
      })
    }
  },
  mounted: function () {
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += ' no-touch-device'
    }
    this.loadCounter = this.loadArray.length
    this.loadImages()
  },
  components: { footbar, navbar }
}

</script>

<style>

/*@import '../static/css/theme.css';*/
@import '../static/css/custom.css';

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-property: opacity;
  -webkit-transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  opacity: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
#app.active {
  opacity: 1!important;
}
/*.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 2s;
}
.fade-enter-active {
  transition-delay: 2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}*/

</style>



// WEBPACK FOOTER //
// App.vue?510e82cd